import React from 'react'
import CalendarFn from 'mondrian-vanilla/core/components/Calendar/calendar'
import {
  CalendarProps,
  Month,
  DaysOfWeek,
  StateProps
} from './type'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [],
  modifiers: ['readOnly'],
  states: []
}

export default function Calendar(props: CalendarProps & StateProps) {
  const {
    name,
    years,
    lockPast = false,
    lockAll = false,
    unlockDays,
    lockDays,
    selectedDay,
    readOnly = false,
    selectedMonth,
    selectedYear,
    ...rest
  } = props

  const calendarRef = React.useRef(null)

  React.useEffect(() => {
    if (!!calendarRef?.current) {

      const cal = CalendarFn(calendarRef?.current)
      // readOnly não pode ser usado com "lockOptions" e nem "unlockDays[]", nem "lockDays[]"
      if (!readOnly) {
        cal.unlockDays(unlockDays)
        cal.lockDays(lockDays)
      }
    }
  }, [calendarRef])

  return (
    <>    <div
      ref={calendarRef}
      className={`${resolveProps(props, config, 'Calendar')}`}
      data-mdn-selected-day={selectedDay}
      data-mdn-selected-month={selectedMonth}
      data-mdn-selected-year={selectedYear}
      data-mdn-lock-past={lockPast}
      data-mdn-lock-all={lockAll}
    >
      <div className="mdn-Calendar-header">
        {readOnly ? (
          <>
            <h3 className="mdn-Calendar-monthTitle mdn-Heading mdn-Heading--sm"></h3>
          </>
        ) : (
          <>
            <div className="mdn-Input mdn-Input--activatedField mdn-Calendar-header-month">
              <select
                id="calendar-month"
                className="mdn-Input-field"
                data-mdn-type="select"
              >
                {Object.values(Month).map((month, index) => {
                  return (
                    <>
                      <option value={month}>{month}</option>
                    </>
                  )
                })}
              </select>
              <label htmlFor="calendar-month" className="mdn-Input-label">
                Mês
              </label>
              <small className="mdn-Input-errorFeedback">
                Por favor, preencha este campo corretamente.
              </small>
            </div>
            <div className="mdn-Input mdn-Input--activatedField mdn-Calendar-header-year">
              <select
                id="search"
                className="mdn-Input-field"
                data-mdn-type="select"
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              <label htmlFor="search" className="mdn-Input-label">
                Ano
              </label>
              <small className="mdn-Input-errorFeedback">
                Por favor, preencha este campo corretamente.
              </small>
            </div>
          </>
        )}
      </div>
      <div className="mdn-Calendar-body">
        <ul className="mdn-Calendar-weekDays">
          {Object.values(DaysOfWeek).map((day, index) => {
            return (
              <li className="mdn-Calendar-weekDays-day" aria-label={day}>
                {day}
              </li>
            )
          })}
        </ul>
        <ul className="mdn-Calendar-weeks"></ul>
      </div>
    </div>
    
    </>
  )
}
